import React, { useRef, useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaLocationDot, FaChevronDown } from 'react-icons/fa6';
import NoteCard from './NoteCard';
import ImageGrid from './ImageGrid';
import { NOTES } from '../data/notes';

function MyObservations() {
  const viewportRef = useRef(null);
  const [showScrollHint, setShowScrollHint] = useState(false);

  const updateScrollHint = useCallback(() => {
    const viewport = viewportRef.current;
    if (!viewport) return;

    const hasMoreBelow =
      viewport.scrollHeight - viewport.scrollTop - viewport.clientHeight > 8;
    setShowScrollHint(hasMoreBelow);
  }, []);

  useEffect(() => {
    updateScrollHint();

    const viewport = viewportRef.current;
    if (!viewport) return undefined;

    const resizeObserver = new ResizeObserver(updateScrollHint);
    resizeObserver.observe(viewport);
    resizeObserver.observe(viewport.firstElementChild);

    return () => resizeObserver.disconnect();
  }, [updateScrollHint]);

  return (
    <section id="notes" className="section things">
      <div className="container">
        <header className="section__header reveal">
          <h2 className="section__title"> Synapses. Synapsing.</h2>
          <p className="section__subtitle">
            A running list of some of my recent thoughts and musings. Proceed
            with caution, my brain can be a wild place.
          </p>

          <p className="notes__location reveal">
            <FaLocationDot className="notes__location-icon" aria-hidden="true" />
            <span>Currently: Doing Bangkok.</span>
          </p>
        </header>

        <div className="things__grid">
          <div className="things__notes-wrap reveal reveal--delay-1">
            <div className="notes-carousel">
              <div
                ref={viewportRef}
                className="notes-carousel__viewport"
                tabIndex={0}
                aria-label="Notes list"
                onScroll={updateScrollHint}
              >
                <div className="notes-carousel__track">
                  {NOTES.map((note) => (
                    <NoteCard key={note.slug} note={note} />
                  ))}
                </div>
              </div>

              <div
                className={`notes-scroll-hint ${showScrollHint ? 'is-visible' : ''}`}
                aria-hidden={!showScrollHint}
              >
                <FaChevronDown />
              </div>
            </div>

            <Link to="/notes" className="btn btn--outline notes-all-btn">
              All My Notes Here
            </Link>
          </div>

          <div className="things__images reveal reveal--delay-2">
            <ImageGrid />
          </div>
        </div>
      </div>
    </section>
  );
}

export default MyObservations;
